import * as jsxRuntime from "C:\\Eido-projects\\75-hannemanns-hus\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment